module.exports = __webpack_public_path__ + "img/landing_img1.43e8286c.png";